/**
 * WCO-3325 — Resolve label production_location from configured transfer-source warehouse.
 * Mirrors @tnb/transfer-facility location semantics using existing production-locations API data.
 */

const HTE_FACILITY_WAREHOUSE_CODE = 'HTE1';
const LEGACY_HTE_WAREHOUSE_CODE = 'HTE';

export interface ProductionLocationRow {
  warehouse_code: string;
  location_code: string;
}

/**
 * Map transfer_source_warehouse_code → production_location for printed labels.
 * Uses ics.production_location rows (warehouse_code → location_code), not physical station.
 */
export function resolveLabelProductionLocation(
  transferSourceWarehouseCode: string | null | undefined,
  productionLocations: ProductionLocationRow[],
): string {
  const warehouseCode = (transferSourceWarehouseCode?.trim() || HTE_FACILITY_WAREHOUSE_CODE);
  const match = productionLocations
    .filter((row) => row.warehouse_code === warehouseCode)
    .sort((a, b) => a.location_code.localeCompare(b.location_code))[0];
  const locationCode = match?.location_code?.trim();
  if (locationCode) return locationCode;
  if (warehouseCode === HTE_FACILITY_WAREHOUSE_CODE) return LEGACY_HTE_WAREHOUSE_CODE;
  return warehouseCode;
}
